var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',[_c('img',{attrs:{"src":require("../../public/homeImg/icon-beian.png"),"alt":""}}),_c('a',{staticStyle:{"color":"#fff"},attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("蜀ICP备2020027237号-1")])]),_c('div',[_vm._v("达州顺泰物流供应链管理有限公司    版权所有")])])
}]

export { render, staticRenderFns }